// --------------- VMS ---------------- //
import { VMSRoutes } from "./routeListsODoctor/VMSRoutes";

interface IRoute {
  path?: string;
  Component: JSX.Element;
  children?: IRoute[];
  exact?: boolean;
}

export const privateRoutesListODoctor: IRoute[] = [
  // VMS ROUTES
  ...VMSRoutes,
];
